import { useCallback, useMemo } from "react"

import { useBuilderStore } from "@/components/builder/utils/store"

export default function useListStores() {
  const { lists } = useBuilderStore()
  const templates = useListStore('template', lists.templates)
  const partials = useListStore('partial', lists.partials)
  const layouts = useListStore('layout', lists.layouts)

  return useMemo(() => ({
    templates,
    partials,
    layouts,
  }), [templates, partials, layouts])
}

/**
 * @template Items
 * @template List
 * @param {string} type
 * @param {{items: Items, list: List}} store
 */

function useListStore(type, { items, list }) {
  const { block: { deleteEntry, save } } = useBuilderStore()
  const handleLoad = useCallback(() => list({ type }), [list, type])

  const handleDelete = useCallback(async data => {
    await deleteEntry(data)
    await handleLoad()
  }, [deleteEntry, handleLoad])

  const handleSave = useCallback(async data => {
    await save(data)
    await handleLoad()
  }, [save, handleLoad])

  return useMemo(() => ({
    items,
    handleLoad,
    handleDelete,
    handleSave,
  }), [items, handleLoad, handleDelete, handleSave])
}
